import { CaseFollowUp } from "./../follow-ups/CaseFollowUp";
import { QueryParams, SortParams, Auditable, Referral, CaseFile, Donor, Tissue, Determination } from "..";

export interface Case extends Auditable {
    tenantId: number;

    hasFlaggedForms: boolean;
    referral?: Referral;
    donor?: Donor;
    determination?: Determination;
    tissues?: Tissue[];
    files?: CaseFile[];
    followUps?: CaseFollowUp[];
}

export const DefaultCaseQueryParams: QueryParams = {
    id: "",
};

export const DefaultCaseSortParams: SortParams = {
    orderBy: "referralId",
    orderDesc: "true",
};
